import { Location } from 'history';
import { isObject } from '../../utils';

import { PerformanceInstance } from './types';
import MetricCalc from './MetricCalc';

declare global {
  interface Window {
    MTPagePerformanceMonitor: PerformanceInstance | undefined;
  }
}

const init = ({ appName = '' }: { appName: string }): void => {
  const MetricCalculator = new MetricCalc(appName);
  MetricCalculator.init();
  defineGlobals(MetricCalculator, appName);
};

const getInstance = () => window.MTPagePerformanceMonitor;

const resetInstance = () => {
  window.MTPagePerformanceMonitor = undefined;
};

/**
 *
 * @param MetricCalculator
 * @param appName
 * Global object will have MTPagePerformanceMonitor
 */
const defineGlobals = (MetricCalculator: MetricCalc, appName: string): void => {
  window.MTPagePerformanceMonitor = {
    context: appName,
    getPerformanceData: MetricCalculator.getPerformanceData.bind(MetricCalculator),
    appTransitionStart: MetricCalculator.appTransitionStart.bind(MetricCalculator),
    addDataToScope: MetricCalculator.addDataToScope.bind(MetricCalculator),
    resetMetric: MetricCalculator.resetMetric.bind(MetricCalculator),
  };
};

/**
 *
 * @param location
 * preRouteUpdateMetrics will either reset performance metrics to empty
 * or will start a new begining for metric calculation.
 */
const preRouteUpdateMetrics = (location: Location): void => {
  let shouldSetTransitionStart = true;
  let fromLocation;
  if (isObject(location) && location.state) {
    const { isInternalApplicationRedirect = false, fromLocation: prevLocation } = location.state;

    fromLocation = prevLocation;
    shouldSetTransitionStart = !isInternalApplicationRedirect;
  }

  if (window.MTPagePerformanceMonitor)
    shouldSetTransitionStart
      ? window.MTPagePerformanceMonitor.appTransitionStart(location, fromLocation)
      : window.MTPagePerformanceMonitor.resetMetric();
};

export { init, getInstance, resetInstance, preRouteUpdateMetrics };
